import { buildTotalFundInvestmentsExpression } from 'pages/Waterfall/utilities';
import { GetFirmInvestmentRowConfigProps } from './getFirmInvestmentRowConfig.props';
import {
  contentClass,
  FIRM_TOTALS_LABEL,
  headerClass,
  OFFSET_TO_STARTING_ROW,
  subtitleClass,
  TOTAL_LABEL,
  totalClassAlignRight,
} from '../../constants';

const addSuffixToSheetName = (sheetName: string, suffix: string) => `${sheetName}${suffix}`;
const getFirmInvestmentRowConfig = ({
  securityCount,
  fundInvestmentsSheetNames,
  investmentsInPortfolioSheetNames,
}: GetFirmInvestmentRowConfigProps) => {
  const fundInvestmentKeys = investmentsInPortfolioSheetNames.map(fund => addSuffixToSheetName(fund, '.@'));
  // create an empty object for every number in securityCount
  const securities = Array.from({ length: securityCount }, () => ({
    value: '',
    readOnly: true,
    className: contentClass,
  })).map((securityRow, index) => ({
    ...securityRow,
    expr: `=SUM(${fundInvestmentKeys.map(fundInvestmentKey => fundInvestmentKey + (index + OFFSET_TO_STARTING_ROW)).join(',')})`,
  }));

  return [
    {
      value: FIRM_TOTALS_LABEL,
      readOnly: true,
      colSpan: 2,
      className: headerClass,
    },
    {
      value: '',
      alias: 'subtitle',
      readOnly: true,
      className: subtitleClass,
    },
    ...securities,
    {
      value: TOTAL_LABEL,
      readOnly: true,
      expr: buildTotalFundInvestmentsExpression(fundInvestmentsSheetNames),
      className: totalClassAlignRight,
    },
  ];
};

export default getFirmInvestmentRowConfig;
